export var CONTROLLED_PROPS = [
    "disabled",
    "onBlur",
    "onChange",
    "onFocus",
    "onMouseDown",
    "readOnly",
    "value"
];
export var defaultFormatChars = {
    "9": /[0-9]/,
    a: /[A-Za-z]/,
    "*": /[A-Za-z0-9]/
};
//# sourceMappingURL=constants.js.map